/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Closing_Title_1Inputs */

const en_home_closing_title_1 = /** @type {(inputs: Home_Closing_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring us the problem`)
};

const lv_home_closing_title_1 = /** @type {(inputs: Home_Closing_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet mums problēmu,`)
};

/**
* | output |
* | --- |
* | "Bring us the problem" |
*
* @param {Home_Closing_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_closing_title_1 = /** @type {((inputs?: Home_Closing_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Closing_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_closing_title_1(inputs)
	return en_home_closing_title_1(inputs)
});